import { render, staticRenderFns } from "./KnowledgeBasePage.vue?vue&type=template&id=7e58f411&"
import script from "./KnowledgeBasePage.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports